<template>
    <v-dialog
      v-model="massUpdateDialog"
      scrollable
      max-width="650"
      persistent
    >
      <v-card 
        :tile="this.$vuetify.breakpoint.xsOnly"
        v-if="typeChosen"
      >
        <v-toolbar flat tile class="flex-grow-0">
          <v-toolbar-title class="font-weight-black title">
            {{ 
              massUpdateType == "suspend" ? 
              $t(`massAgentsSuspensionTitle${$vuetify.breakpoint.xsOnly ? 'Mobile' : ''}`) : 
              $t(`massAgentsActivationTitle${$vuetify.breakpoint.xsOnly ? 'Mobile' : ''}`) 
            }}
          </v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="px-8 py-4">
          {{
            massUpdateType == "suspend" ? 
            $t("massAgentsSuspensionContent") : 
            $t("massAgentsActivationContent") 
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">
            {{ $t("toCancel") }}
          </v-btn>
          <v-btn color="primary" text @click="massUpdate">
            {{ $t("toConfirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-toolbar flat tile class="flex-grow-0">
          <v-toolbar-title class="font-weight-black title">
            {{ 
              $t(`massAgentsUpdateTitle${$vuetify.breakpoint.xsOnly ? 'Mobile' : ''}`) 
            }}
          </v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="px-8 py-4">
          {{
            $t("massAgentsUpdateContent", { managerName })
          }}
          <v-radio-group v-model="massUpdateType">
            <v-radio
              value="suspend"
              :label="$t('suspension')"
            />
            <v-radio
              value="activation"
              :label="$t('activation')"
            />
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="massUpdate" class="mr-2 mb-2">
            {{ $t("toSave") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: "MassAgentUpdateDialog",
  props: ["userId", "managerLevel", "managerName"],
  data: () => ({
    typeChosen: false,
    massUpdateType: "",
  }),
  computed: {
    massUpdateDialog() {
      return this.$store.state.massUpdateDialog;
    },
  },
  methods: {
    chooseMassUpdateType() {
      this.typeChosen = true;
    },
    massUpdate() {
      let body = {};

      if (this.managerLevel == "local") {
        body.local_id = this.userId;
      } else {
        body.regional_id = this.userId;
      }

      const endpoint = this.massUpdateType === 'suspend' ? 
        `/administrator/${this.managerLevel}s/suspendAllAgents` : `/administrator/${this.managerLevel}s/activateAllAgents`;
      
      this.$request.post(endpoint, body)
      .then((res) => {
        this.$store.commit("massUpdateDialog", false);
        if (res.messages) {
          this.$store.commit("setFeedbackSnack", {
            msg: res.messages,
            color: "success",
          });
        }
      });
    },
    closeDialog() {
      this.$store.commit("massUpdateDialog", false);
    },
  },
}
</script>